import { useAuth } from "@/auth/useAuth";

/** Право правки планов «Аналитики МП»: админ или страница-право mp_plans_edit. */
export function useMpPlansEdit(): boolean {
  const { user } = useAuth();
  if (!user) return false;
  return user.is_admin || user.permissions.includes("mp_plans_edit");
}
